// Decorative fill-tier icon. The artwork lives at /images/icon-interesting.png
// (static, CloudFront-cacheable) instead of base64 inside the JS bundle —
// S4 from the 2026-06-11 home-LCP investigation.
const InterestingIcon = ({ size = "12px" }) => {
  return (
    <img
      src="/images/icon-interesting.png"
      alt=""
      decoding="async"
      style={{ width: size, height: size }}
    />
  );
};

export default InterestingIcon;
